import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FiatDepositService } from 'src/app/api/fiat-deposit.service';
import { FiatDeposit, FiatDepositType } from 'src/app/models/fiat-deposit';
import { timestamp } from 'src/app/helpers/helpers';
import { FiatTransactionStatus } from 'src/app/models/fiat-transaction-status';

@Component({
  selector: 'fiat-deposit-ticket',
  templateUrl: './fiat-deposit-ticket.component.html',
  styleUrls: ['./fiat-deposit-ticket.component.scss']
})
export class FiatDepositTicketComponent implements OnInit {
  @Input() form: FormGroup;

  deposits: FiatDeposit[];

  constructor(private fiatDepositService: FiatDepositService) { }

  ngOnInit() {
    this.fiatDepositService.list(20, null, FiatDepositType.WIRE).subscribe(response => {
      this.deposits = response.edges
        .map(item => item.node)
        .filter(item => [FiatTransactionStatus.UNCONFIRMED, FiatTransactionStatus.PROCESSING, FiatTransactionStatus.PENDING].includes(item.status));
    });

    this.deposit.valueChanges.subscribe((value: FiatDeposit) => {
      if (value && value.dateCreated) {
        const date = new Date(timestamp(value.dateCreated));
        this.transerDate.setValue(date.toDateString());
      }
    });
  }

  onFileSelect(file) {
    this.form.get('onlineMoneyTransfer.passport').setValue({
      name: file.file.name,
      content: file.base64
    });
  }

  onFileRemove() {
    this.form.get('onlineMoneyTransfer.passport').reset();
  }

  get bankAccountHolderName() { return this.form.get('onlineMoneyTransfer.bankAccountHolderName'); }
  get deposit() { return this.form.get('onlineMoneyTransfer.deposit'); }
  get transerDate() { return this.form.get('onlineMoneyTransfer.transferDate'); }

}
